// import React from "react";
// import logo from "../assets/images/logo2.png"
// const ChatBubble = ({ text, isUser, data }) => {
//     console.log(text, "text")
//     console.log(isUser, "isUser")
//     console.log(data, "data")


//     return (

//         <>
//             <div
//                 style={{
//                     display: "flex",
//                     justifyContent: isUser ? "flex-end" : "flex-start",
//                     margin: "8px 0"
//                 }}
//             >
//                 <div className="icon-img-box">
//                 <img src={logo} className="icon-image"/>
//                 </div>
//                 <div
//                     style={{
//                         backgroundColor: isUser ? "#8e44ad" : "#007bff",
//                         color: "#fff",
//                         padding: "10px 15px",
//                         borderRadius: "15px",
//                         maxWidth: "70%",
//                         border: isUser ? "1px solid #ccc" : "none",
//                         textAlign: "left",
//                         whiteSpace: "pre-line"
//                     }}
//                 >
//                     {text}
//                 </div>
//             </div>
//         </>


//     );
// };

// export default ChatBubble;



import React from "react";
import userIcon from "../assets/images/lgn.png";   // Add your user icon
import botIcon from "../assets/images/logo2.png";     // Add your bot icon

const ChatBubble = ({ text, isUser }) => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: isUser ? "flex-end" : "flex-start",
                marginBottom: "10px",
            }}
        >
            {!isUser && (
                <img
                    src={botIcon}
                    alt="Bot"
                    style={{ width: 30, height: 30,
                    marginRight: 10,
                    marginTop: "10px",
                    boxShadow: "rgba(0, 0, 0, 0.16) 2px 4px 6px, rgba(0, 0, 0, 0.23) 3px 2px 3px",
                    borderRadius: "50%" }}
                />
            )}
            <div
                style={{
                    maxWidth: "70%",
                    padding: "10px 15px",
                    borderRadius: "15px",
                    backgroundColor: isUser ? "#ff7800" : "#0c1538",
                    border: isUser ? "1px solid #ccc" : "none",
                    color: "#fff",
                    textAlign: "left",
                    whiteSpace: "pre-line",
                    marginTop: "10px",
                    fontSize:"12px",
                    fontWeight:"300",
                }}
            >
                {text}
            </div>
            {isUser && (
                <img
                    src={userIcon}
                    alt="User"
                    style={{
                        width: 30, height: 30,
                        marginLeft: 10,
                        marginTop: "10px",
                        boxShadow: "rgba(0, 0, 0, 0.16) 2px 4px 6px, rgba(0, 0, 0, 0.23) 3px 2px 3px",
                        borderRadius: "50%"
                    }}
                />
            )}
        </div>
    );
};

export default ChatBubble;





// import React from "react";
// import userIcon from "../assets/images/images-1.jpeg";
// import adminIcon from "../assets/images/images-2.jpeg";
// import botIcon from "../assets/images/images-2.jpeg";

// const ChatBubble = ({ text, isUser, sender = "user" }) => {
//     const icon = sender === "admin" ? adminIcon : sender === "bot" ? botIcon : userIcon;
//     const align = isUser ? "flex-end" : "flex-start";

//     return (
//         <div style={{ display: "flex", justifyContent: align, marginBottom: "10px" }}>
//             {sender !== "user" && (
//                 <img src={icon} alt={sender} style={{ width: 30, height: 30, marginRight: 10 }} />
//             )}
//             <div style={{
//                 maxWidth: "70%",
//                 padding: "10px",
//                 borderRadius: "10px",
//                 background: isUser ? "#d1e7dd" : "#ffffff",
//                 border: "1px solid #ccc",
//             }}>
//                 {text}
//             </div>
//             {sender === "user" && (
//                 <img src={icon} alt={sender} style={{ width: 30, height: 30, marginLeft: 10 }} />
//             )}
//         </div>
//     );
// };

// export default ChatBubble;
